import { request } from "../httpClient";

function getUrl(prefixKey) {
  const prefix = (window.appConfig && window.appConfig[prefixKey]);
  return process.env.REACT_APP_API_URL + prefix;
}

export async function fetchCarbonIntensity({ queryKey }) {
  const [,start_date, end_date, zone, resolution, timeout] = queryKey;
  const url = `${getUrl("getCarbonIntensityUrl")}` +
    `?start_date=${encodeURIComponent(start_date)}&end_date=${encodeURIComponent(end_date)}&zone=${encodeURIComponent(zone)}&resolution=${encodeURIComponent(resolution)}`;
  return request(url, {}, timeout);
}